import React from "react";
import { IconT } from "types/utils";

export default function ProposalStatusCompleteIcon({ height = "32", width = "32" }: IconT) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#019E6F" />
      <path
        d="M22.8071 16.6233V11.3992C22.8071 9.85934 22.8071 9.0894 22.5249 8.50125C22.2767 7.9839 21.8807 7.56328 21.3935 7.29968C20.8398 7 20.1148 7 18.6649 7H13.1421C11.6922 7 10.9673 7 10.4135 7.29968C9.9264 7.56328 9.53036 7.9839 9.28216 8.50125C9 9.0894 9 9.85934 9 11.3992V20.9308C9 22.4707 9 23.2406 9.28216 23.8287C9.53036 24.3461 9.9264 24.7667 10.4135 25.0303C10.9673 25.33 11.6922 25.33 13.1421 25.33H15.9035M17.6294 15.2485H12.4518M14.1776 18.9145H12.4518M19.3553 11.5825H12.4518M18.0609 22.5805L19.7868 24.4135L23.67 20.2893"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
